export const boxStyles = {
  gap: '40px',
  minHeight: 0,

  '& > div': {
    padding: 0,
  },
};
